<template>
  <Stack id="header" class="stk-py-8">
    <div v-if="hasFetchedTree" class="grid">
      <!-- Entity Tree with checkboxes explicitly disabled -->
      <EntityTree
        class="tree"
        :tree-data="treeData"
        :current-entity-id="entityExternalId"
        :show-checkboxes="false"
      />
      <EntityGroups
        class="groups"
        :entity-external-id="entityExternalId"
        :current-parent="currentParent"
      />
    </div>

    <LoaderWithText v-else>
      Fetching relationships…
    </LoaderWithText>
  </Stack>
</template>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--stk-size-8);
}

.tree {
  grid-column: 1;
}

.groups {
  grid-column: 2;
}
</style>

<script>
import EntityPermissions from './EntityPermissions.vue';
import EntityGroups from './EntityGroups.vue';
import EntityTree from './EntityTree.vue';
import { LoaderWithText, Stack } from '@stakeui';

export default {
  name: 'PermissionsGroups',
  components: {
    EntityPermissions,
    EntityGroups,
    EntityTree,
    LoaderWithText,
    Stack,
  },
  props: {
    entityExternalId: {
      type: String,
      required: true,
    },
    entity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      treeData: null,
      currentParent: null, // Store the result here instead of computing it directly
      hasFetchedTree: false,
    };
  },
  
  created() {
    this.fetchEntityTree();
  },

  watch: {
    treeData(newTreeData) {
      if (newTreeData) {
        this.updateCurrentParent();
      }
    },
    entity: {
      deep: true,
      handler(newEntity) {
        if (newEntity) {
          this.updateCurrentParent();
        }
      },
    },
  },
  methods: {
    async fetchEntityTree() {
      try {
        const response = await fetch(`/api/v1/entities/${this.entityExternalId}/tree/`);
        if (!response.ok) throw new Error('Failed to fetch entity tree');
        this.treeData = await response.json();
      } catch (error) {
        console.error(error);
      } finally {
        this.hasFetchedTree = true;
      }
    },

    updateCurrentParent() {
      if (!this.entity?.parent_entities?.length || !Array.isArray(this.treeData)) {
        this.currentParent = null;
        return;
      }

      const findEntityById = (nodes, id) => {
        for (const node of nodes) {
          if (node?.entity?.id === id) return node.entity;
          if (Array.isArray(node.descendants)) {
            const found = findEntityById(node.descendants, id);
            if (found) return found;
          }
        }
        return null;
      };

      const parentEntity = findEntityById(this.treeData, this.entity.parent_entities[0]);
      if (parentEntity) {
        this.currentParent = parentEntity;
      }
    },
  },
};
</script>
